/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trialSuffix: NonNullable<unknown> }} Ccsl_Export_Footer_CreatedInputs */

const en_ccsl_export_footer_created = /** @type {(inputs: Ccsl_Export_Footer_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created using Closed Caption Creator 8${i?.trialSuffix}`)
};

const fr_ccsl_export_footer_created = /** @type {(inputs: Ccsl_Export_Footer_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cree avec Closed Caption Creator 8${i?.trialSuffix}`)
};

const de_ccsl_export_footer_created = /** @type {(inputs: Ccsl_Export_Footer_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erstellt mit Closed Caption Creator 8${i?.trialSuffix}`)
};

const it_ccsl_export_footer_created = /** @type {(inputs: Ccsl_Export_Footer_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Creato utilizzando Closed Caption Creator 8${i?.trialSuffix}`)
};

const ru_ccsl_export_footer_created = /** @type {(inputs: Ccsl_Export_Footer_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Создано с помощью программы для создания субтитров Closed Caption Creator 8${i?.trialSuffix}`)
};

const es_ccsl_export_footer_created = /** @type {(inputs: Ccsl_Export_Footer_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Creado con Closed Caption Creator 8${i?.trialSuffix}`)
};

const zh_cn2_ccsl_export_footer_created = /** @type {(inputs: Ccsl_Export_Footer_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`使用 Closed Caption Creator 8${i?.trialSuffix} 创建`)
};

const ja_ccsl_export_footer_created = /** @type {(inputs: Ccsl_Export_Footer_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`クローズドキャプションクリエーター 8${i?.trialSuffix} を使用して作成`)
};

const hi_ccsl_export_footer_created = /** @type {(inputs: Ccsl_Export_Footer_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्लोज्ड कैप्शन क्रिएटर 8${i?.trialSuffix} का उपयोग करके बनाया गया`)
};

const pt_pt2_ccsl_export_footer_created = /** @type {(inputs: Ccsl_Export_Footer_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Criado usando o Closed Caption Creator 8${i?.trialSuffix}`)
};

/**
* | output |
* | --- |
* | "Created using Closed Caption Creator 8{trialSuffix}" |
*
* @param {Ccsl_Export_Footer_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_footer_created = /** @type {((inputs: Ccsl_Export_Footer_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Footer_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_footer_created(inputs)
	if (locale === "de") return de_ccsl_export_footer_created(inputs)
	if (locale === "it") return it_ccsl_export_footer_created(inputs)
	if (locale === "ru") return ru_ccsl_export_footer_created(inputs)
	if (locale === "es") return es_ccsl_export_footer_created(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_footer_created(inputs)
	if (locale === "ja") return ja_ccsl_export_footer_created(inputs)
	if (locale === "hi") return hi_ccsl_export_footer_created(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_footer_created(inputs)
	return en_ccsl_export_footer_created(inputs)
});